import { SharedModule } from '@app/@shared';
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';
import { TransformNumberPipe } from '@app/@shared/pipes/transform-number.pipe';
import { CurrentMonthTableComponent } from './current-month-table/current-month-table.component';

@NgModule({
  imports: [
    FlexLayoutModule,
    MaterialModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [CurrentMonthTableComponent],
  exports: [CurrentMonthTableComponent],
  providers: [DecimalPipe, TransformNumberPipe],
})
export class ActivitySharedModule {}
